export default "__VITE_ASSET__C77k4cdC__"